import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const duplicateCheckoutExperience = {
  name: "duplicateCheckoutExperience" as const,
  input: z.object({ checkoutExperienceId: zExt.objectId() }),
  output: z.object({ checkoutExperienceId: zExt.objectId() }),
};
